import { Injectable, Inject } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class TokenService {
  constructor(private router: Router) { }

  /**
   * Obtiene el token de autenticacion del local storage
   */
  getToken() {
    return localStorage.getItem('access_token');
  }
  /**
   * Da valor al token en el local storage
   * @param value valor del token
   */
  setToken(value: string) {
    localStorage.setItem('access_token', value);
  }

  /**
   * Elimina el token del local storage.
   * Al acceder a la llave retornará null
   */
  removeToken() {
    localStorage.removeItem('access_token');
  }

  /**
   * Chequeo de error
   * @param err el código de error de la petición
   */
  errorHandler(err) {
    if (err == 401 || err == 403) {
      this.router.navigate(['login']);
      this.removeToken();
    }
  }
}
